import React from 'react'

const TagItem = ({ text, disabled, className, style }) => (
  <span style={style} className={`text-violet-dark border-yellow bg-yellow-lightest leading-14 font-thin rounded-full text-sm px-2 py-1 ${className || ''}`}>{text}</span>
)

export default TagItem

